module.exports = "//d274d294w9cx2v.cloudfront.net/56f0792018b4e07165a29edc72fc47e026f50ea0/images/photo-couple.png";